export default "__VITE_ASSET__Bc8PGSDt__"